import { createApp } from "vue";
import App from "@/modules/AvailabilityCalendar/App.vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { pinia } from "~/store";
import "@/assets/style/style.scss";

const app = createApp(App);
app.use(pinia);
app.use(VueQueryPlugin);

app.mount("#availabilitycalendar");
